import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import API from "@/lib/api";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate("/login"); return; }

    const sessionId = match[1];
    (async () => {
      try {
        const { data } = await API.post("/auth/session", { session_id: sessionId });
        localStorage.setItem("token", data.token);
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(data.is_new_user ? "/profile" : "/", { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF9F6]" data-testid="auth-callback">
      <div className="text-center">
        <div className="animate-spin w-8 h-8 border-2 border-primary border-t-transparent rounded-full mx-auto mb-4" />
        <p className="text-sm text-stone-500">Signing you in...</p>
      </div>
    </div>
  );
}
